export default __webpack_public_path__ + "static/23-5ea26143072a30fc9efc56b01e6862a9.jpg";